import React from "react";
import trashBoxRed from "../../../assets/svg/trash-red.svg";
import eye from "../../../assets/svg/eye-preview.svg";
import cross from "../../../assets/svg/cross-gray.svg";
import tick from "../../../assets/svg/tick-white.svg";

export default function ControlPanel() {
  return (
    <div className="flex gap-2 items-center">
      <button className="flex gap-2 px-4 py-[9px] border rounded-lg border-[#AFB7CA] font-semibold text-[15px] text-[#5F6B88]">
        <img src={eye} alt="" />
        Предв. просмотр
      </button>
      <button className="flex gap-2 px-4 py-[9px] border rounded-lg border-[#AFB7CA] font-semibold text-[15px] text-[#5F6B88]">
        <img src={cross} alt="" />
        Вернуть в черновик
      </button>
      <button className="flex gap-2 px-4 py-[9px] border rounded-lg border-[#F12D2D] font-semibold text-[15px] text-[#F12D2D]">
        <img src={trashBoxRed} alt="" />
        Удалить
      </button>
      <button className="flex gap-2 px-4 py-[9px] border rounded-lg border-[#3BBC30] font-semibold text-[15px] text-white bg-[#3BBC30]">
        <img src={tick} alt="" />
        Сохранить
      </button>
    </div>
  );
}
